import {
  Box,
  FormControlSizes,
  MultiSelectCheckboxDropdown,
  Tooltip,
  type FilterableSelectProperty,
} from '@talos/kyoko';

interface PriceGridMultiSelectFilterProps {
  width: string;
  tooltip: string;
  defaultLabel: string;
  property: FilterableSelectProperty<string, string>;
  selections: string[];
  onSelectionsChange: (selections: string[]) => void;
  buttonTestID: string;
}

export function PriceGridMultiSelectFilter({
  width,
  tooltip,
  defaultLabel,
  property,
  selections,
  onSelectionsChange,
  buttonTestID,
}: PriceGridMultiSelectFilterProps) {
  return (
    <Box w={width} display="flex" alignItems="center" alignSelf="center">
      <Tooltip tooltip={tooltip} placement="top-start" targetStyle={{ display: 'flex', width: '100%' }}>
        <MultiSelectCheckboxDropdown
          prefix={null}
          defaultLabel={defaultLabel}
          property={property}
          selections={selections}
          onSelectionsChange={onSelectionsChange}
          buttonTestID={buttonTestID}
          size={FormControlSizes.Small}
        />
      </Tooltip>
    </Box>
  );
}
